import { ComponentType } from "react";
import { Container, styled, ContainerProps } from "@material-ui/core";
import {
  spacing,
  compose,
  sizing,
  SizingProps,
  SpacingProps,
} from "@material-ui/system";
export type ExtendedContainer = Omit<ContainerProps, "maxWidth"> &
  SizingProps &
  SpacingProps;
export const ExtendedContainer: ComponentType<ExtendedContainer> = styled(
  Container,
)(compose(spacing, sizing));
